import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DealerMap from "./pages/DealerMap";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DealerMap />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
